import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTrialResults } from 'api/requests';

export const fetchTrialResults = createAsyncThunk(
    'trialResults/fetchTrialResults',
    async ({ language = 'en', country = 'en' } = {}) => {
        try {
            const response = await getTrialResults(language, country);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

const trialResultsSlice = createSlice({
    name: 'trialResults',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchTrialResults.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTrialResults.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchTrialResults.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default trialResultsSlice.reducer;
